import { combineReducers } from 'redux';

import { reducer as detailsReducer } from './details';
import { reducer as followReducer } from './follow';
import { reducer as allReducer } from './all';
import { reducer as couponsReducer } from './coupons';
import {reducer as recommendedReducer } from './recommended';
import { reducer as affiliateCouponsReducer } from './affiliateCoupons';

export default combineReducers({
  details: detailsReducer,
  follow: followReducer,
  all: allReducer,
  coupons: couponsReducer,
  recomended: recommendedReducer, 
  affiliateCoupons: affiliateCouponsReducer,
});
